// @flow

import React, { type Node } from 'react';
import GenericExperiment from 'app/packages/pinterest-experiments/Experiment';
import { RequestContextConsumer } from 'app/common/react/components/RequestContext';

type Props = {|
  activate?: boolean,
  children: ({ group: string, anyEnabled: boolean, customActivate: ?() => string }) => Node,
  isEligible?: boolean,
  name: string,
|};

export default function Experiment({ activate, children, isEligible, name }: Props): Node {
  return (
    <RequestContextConsumer>
      {(requestContext) => (
        <GenericExperiment
          activate={activate}
          activateExperiment={(expName: string): string =>
            requestContext.experiments.v2ActivateExperiment(expName) || ''
          }
          group={requestContext.experiments.v2GetGroup(name) || ''}
          isEligible={isEligible}
          name={name}
        >
          {children}
        </GenericExperiment>
      )}
    </RequestContextConsumer>
  );
}
